module.exports = __webpack_public_path__ + "img/browse-vehicles-search-hero-nissan.4f37c0eb.png";